import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './index';
export function BreadcrumbSkeleton({ items = 2, itemWidth = 120, }) {
    return (_jsx("div", { className: "flex gap-2 items-center", children: Array.from({ length: items }).map((_, index) => (_jsx(Skeleton, { width: itemWidth, height: 16, borderRadius: 6 }, index))) }));
}
